import Cookies from 'js-cookie'

const COOKIE_NAME = 'MergeLogsFeatureKey'

// Usage from the JavaScript console:
//   To set the Merge Logs Feature Key:
//     setMergeLogsFeatureKey('yourKeyHere')
//   To get the stored Merge Logs Feature Key:
//     getMergeLogsFeatureKey()
//   To remove the Merge Logs Feature Key:
//     removeMergeLogsFeatureKey()

export function setMergeLogsFeatureKey(value: string): void {
  Cookies.set(COOKIE_NAME, value, { path: '/', sameSite: 'Lax' })
}

export function getMergeLogsFeatureKey(): string | undefined {
  return Cookies.get(COOKIE_NAME)
}

export function removeMergeLogsFeatureKey(): void {
  Cookies.remove(COOKIE_NAME, { path: '/' })
}

declare global {
  interface Window {
    setMergeLogsFeatureKey: typeof setMergeLogsFeatureKey
    getMergeLogsFeatureKey: typeof getMergeLogsFeatureKey
    removeMergeLogsFeatureKey: typeof removeMergeLogsFeatureKey
  }
}

if (typeof window !== 'undefined') {
  window.setMergeLogsFeatureKey = setMergeLogsFeatureKey
  window.getMergeLogsFeatureKey = getMergeLogsFeatureKey
  window.removeMergeLogsFeatureKey = removeMergeLogsFeatureKey
}
